module.exports = __webpack_public_path__ + "img/card1.7b3e8a68.png";